import { Box, Button, FormControl, Grid, InputLabel, MenuItem, Paper, Select, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography } from "@material-ui/core";
import { Autocomplete } from "@mui/material";
import { useEffect, useState } from 'react';
import PageTitle from "../../../components/PageTitle/PageTitle";
import axios from '../../../utils/axios';
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@material-ui/core"

const FundTransferRequest = () => {
  const [companies, setCompanies] = useState([]);   // store API response
  const [selectedCompany, setSelectedCompany] = useState(""); // store selected company
  const [beneficiaries, setBeneficiaries] = useState([]);
  const [selectedBeneficiary, setSelectedBeneficiary] = useState("");
  const [rows, setRows] = useState([]);
  const [year, setYear] = useState(new Date().getFullYear()); 
  const [amount, setAmount] = useState(""); // store input amount
  const [signatories, setSignatories] = useState([]);
  const [primarySelected, setPrimarySelected] = useState(null);
  const [secondarySelected, setSecondarySelected] = useState(null);
  const [subject, setSubject] = useState("Electronic Fund Transfer Request.");

  const [openBeneficiaryModal, setOpenBeneficiaryModal] = useState(false);
  const [openModal, setOpenModal] = useState(false);
const [formData, setFormData] = useState({
  beneficiaryName: "",
  name: "",
  accountNo: "",
  bank: null,
  branch: null,
});





  const handleBranchChange = (event, value) => {
    setFormData({
      ...formData,
      branch: value,
      routingNo: value ? value.routingNo : "",
    });
  };


const [banks, setBanks] = useState([]);
const [branches, setBranches] = useState([]);
  const [selectedDate, setSelectedDate] = useState(() => {
  // default today in YYYY-MM-DD format
  const today = new Date();
  return today.toISOString().split("T")[0];
});
const handleOpen = () => setOpenModal(true);

// close modal (cancel or after submit)
const handleClose = () => {
  resetForm();
  setOpenModal(false);
  setOpenBeneficiaryModal(false);
  setBranches([]);
  
};

  useEffect(() => {
    // Call API when component loads
    axios
      .get("/bank-bo/list-all/Cash")
      .then((res) => {
        if (res.data.success) {
          setCompanies(res.data.payload); // save API data to state
        }
      })
      .catch((err) => {
        console.error("Error fetching companies:", err);
      });
  }, []);


   // fetch beneficiaries API
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get("/beneficiaries/approved");
        if (res.data.success) {
        
          setBeneficiaries(res.data.payload);
        }
      } catch (error) {
        console.error("Error fetching beneficiaries:", error);
      }
    };
    fetchData();
  }, []);

useEffect(() => {
  const fetchSignatories = async () => {
    try {
      const res = await axios.get("/signatories");
      if (res.data.success) {
        setSignatories(res.data.payload);
      }
    } catch (error) {
      console.error("Error fetching signatories:", error);
    }
  };

  fetchSignatories();
}, []);

const primaryOptions = signatories.filter((s) => s.signatoryType === "Primary");
const secondaryOptions = signatories.filter((s) => s.signatoryType === "Secondary");


useEffect(() => {
  const fetchBanks = async () => {
    try {
      const res = await axios.get("/bank/get-all-bank-names");
      if (res.data.success) {
        setBanks(res.data.payload);
      }
    } catch (err) {
      console.error(err);
    }
  };
  fetchBanks();
}, []);



const handleBankChange = async (event, value) => {
  setFormData({ ...formData, bank: value, branch: null });
  setBranches([]);
  if (value) {
    try {
      const res = await axios.post("/bank/get-all-banks-by-name", {
        bankName: value.bankName,
      });
      if (res.data.success) {
        setBranches(res.data.payload);
      }
    } catch (error) {
      Swal.fire("Error", "Failed to load branches", "error");
    }
  }
};

// submit
const handleSubmitBeneficiary = async () => {
  if (!formData.name || !formData.accountNo || !formData.bank) {
    Swal.fire("Missing Info", "Please fill all required fields.", "warning");
    return;
  }

  const payload = {
    beneficiaryName: formData.beneficiaryName,
    name: formData.name,
    accountNo: formData.accountNo,
    bankId: formData.branch.id,    // ✅ use id
    // branchId: formData.branch?.id, // ✅ optional
    status:1
  };

  try {
    const res = await axios.post("/beneficiaries", payload);
    if (res.data.success) {
      Swal.fire("Success", "Beneficiary added successfully!", "success");
      // reload beneficiary list
      setBeneficiaries((prev) => [...prev, res.data.payload]);
      handleClose(); // ✅ clear + close
    }
  } catch (error) {
    Swal.fire("Error", "Failed to add beneficiary", "error");
  }
};

// clear helper
const resetForm = () => {
  setFormData({
    beneficiaryName: "",
    name: "",
    accountNo: "",
    bank: null,
    branch: null,
  });
};



const handleAddRow = () => {
    if (!selectedBeneficiary || Number(amount) <= 1) return;

    const beneficiary = beneficiaries.find(b => b.id === selectedBeneficiary.id);

    if (beneficiary) {
      setRows([
        ...rows,
        {
          ...beneficiary,
          amount,
        }
      ]);
      setSelectedBeneficiary(null);
      setAmount(""); // reset amount input
    }
  };
const handleSubmit = async () => {
  if (!selectedCompany) {
    Swal.fire("Missing Info", "Please select a company.", "warning");
    return;
  }
  if (!primarySelected || !secondarySelected) {
    Swal.fire("Missing Info", "Please select both Primary and Secondary signatories.", "warning");
    return;
  }
  if (rows.length === 0) {
    Swal.fire("Missing Info", "Please add at least one beneficiary row.", "warning");
    return;
  }


  const payload = {
    refNo: `CMSF/ACC/${selectedCompany ? selectedCompany.tradeCode : "XXX"}/${year}/`,
    date: selectedDate,
    subject: subject,
    primarySignatoryId: primarySelected.id,
    secondarySignatoryId: secondarySelected.id,
    bankBoId: selectedCompany.id,
    details: rows.map((row) => ({
      beneficiaryId: row.id,
      amount: row.amount,
    })),
    eftType: "General"

  };
// Calculate values
const numberOfAccountHolders = rows.length;
const totalAmount = rows
  .reduce((sum, item) => sum + Number(item.amount || 0), 0)
  .toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

// Step 1: Ask for confirmation
const confirmResult = await Swal.fire({
  title: "Are you sure?",
  html: `
    <p>Do you want to submit this EFT request?</p>
    <hr />
    <p><strong>Number of Account Holders:</strong> ${numberOfAccountHolders}</p>
    <p><strong>Total Amount (BDT):</strong> ${totalAmount}</p>
  `,
  icon: "question",
  showCancelButton: true,
  confirmButtonText: "Yes, Submit",
  cancelButtonText: "Cancel",
});


  if (!confirmResult.isConfirmed) return;
  try {
    const res = await axios.post("/fund-transfer-requests", payload);
    if (res.data.success) {
      Swal.fire({
        title: "Success!",
        text: "Submitted successfully!",
        icon: "success",
        confirmButtonText: "OK",
      }).then(() => {
        // setRows([]);
        // setSelectedCompany(null);
        // setPrimarySelected(null);
        // setSecondarySelected(null);
        window.location.href = "/app/eft/fundTransferRequestList";
      });
    } else {
      Swal.fire("Error", "Submission failed: " + res.data.message, "error");
    }
  } catch (error) {
    console.error("Error submitting:", error);
    Swal.fire("Error", "Something went wrong!", "error");
  }
};



  return (
    <>
         {/* 🔹 Title + Add Button */}
                  <Grid
            container
            alignItems="center"
            justifyContent="space-between"
            style={{ marginBottom: "10px" }}
          >
            {/* Left side: title */}
            <Grid item>
              <PageTitle title="Electronic Fund Transfer Form (General)" />
            </Grid>

            {/* Right side: buttons in one line */}
            <Grid item>
              <Grid container spacing={2}>
                <Grid item>
                  <Link to="/app/eft/fundBeneficiariesList">
                    <Button variant="contained" color="primary">
                      Beneficiarie List
                    </Button>
                  </Link>
                </Grid>
                  <Grid item>
                  <Link to="/app/eft/fundTransferRequestList">
                    <Button variant="contained" color="primary">
                      Back to Fund Transfer List
                    </Button>
                  </Link>
                </Grid>
              </Grid>
              
            </Grid>
            
          </Grid>


         {/* Dropdown */}
      <Grid container spacing={1}>
        <Grid item lg={3} md={6} sm={12} xs={12}>
          <FormControl fullWidth>
            <InputLabel id="company-label">Bank Name</InputLabel>
            <Select
              labelId="company-label"
              value={selectedCompany?.id || ""}
              onChange={(e) => {
                const comp = companies.find((c) => c.id === e.target.value);
                setSelectedCompany(comp);
              }}
            >
              {companies.map((company) => (
                <MenuItem key={company.id} value={company.id}>
                  {company.companyName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>
     

      <Paper style={{ padding: 15, marginTop: 5 }}>
                  {/* Header */}
                <Grid container justifyContent="space-between" alignItems="center">
            <Box display="flex" alignItems="center">
              <Typography variant="body2" style={{ marginRight: 3 }}>
                Ref No: CMSF/ACC/
                {selectedCompany ? selectedCompany.tradeCode : "XXX"}/
                {year}/
              </Typography>
              {/* <TextField
                value={sequence}
                onChange={(e) => setSequence(e.target.value)}
              
                size="small"
                style={{ width: 90 }}
              /> */}
            </Box>

                  <TextField
                  label="Date"
                  type="date"
                  size="small"
                  value={selectedDate}
                  onChange={(e) => setSelectedDate(e.target.value)}
                  InputLabelProps={{
                    shrink: true, // ensures the label doesn't overlap
                  }}
                />
          </Grid>


        {/* Address (Dynamic) */}
        <Box mt={1}>
          <Typography variant="body2">Manager</Typography>
          <Typography variant="body2">
            {selectedCompany ? selectedCompany.companyName : "Bank Name"}
          </Typography>
          <Typography variant="body2">
            {selectedCompany ? selectedCompany.branch : "Branch Name"}
          </Typography>
          <Typography variant="body2">
            {selectedCompany ? selectedCompany.address : "Address Line"}
          </Typography>
        </Box>


        {/* Subject */}

              <Grid container spacing={2} style={{ marginTop: 10 }}>
          <Grid item xs={6}> 
            <FormControl fullWidth>
              <InputLabel id="subject-label">Subject</InputLabel>
              <Select
                labelId="subject-label"
                value={subject}            
                onChange={(e) => setSubject(e.target.value)}
              >
                <MenuItem value="Electronic Fund Transfer Request.">
                  Electronic Fund Transfer Request.
                </MenuItem>
                <MenuItem value="RTGS Fund Transfer Request.">
                  RTGS Fund Transfer Request.
                </MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>


        {/* Body */}
        <Box >
          <Typography variant="body2" paragraph>
            Dear Sir,
          </Typography>
          <Typography variant="body2" paragraph>
            Please transfer the following fund from our special notice deposit
            bank account no.{" "}
            <b>
              {selectedCompany ? selectedCompany.accountNumber : "___________"}
            </b>{" "}
            maintained with your bank to the respective bank account of the
            beneficiaries as per the information given below:
          </Typography>
        </Box>

  <Grid item xs={3}>
          <Button
            variant="outlined"
            color="secondary"
            onClick={() => setOpenBeneficiaryModal(true)}
          >
            Add Beneficiary
          </Button>
        </Grid>

        {/* Table */}
           <p>BeneficiaryName- (Account No-A/C Name)</p>
          <Grid container spacing={1} alignItems="center" style={{ marginTop: 10 }}>  
             
        <Grid item xs={7}>
       
          <Autocomplete
            options={beneficiaries}
            getOptionLabel={(option) =>
              option ? `${option.beneficiaryName} - (${option.accountNo} - ${option.name})` : ""
            }
            value={selectedBeneficiary}
            onChange={(event, newValue) => setSelectedBeneficiary(newValue)}
            isOptionEqualToValue={(option, value) => option.id === value.id} // ✅ ensures match
            clearOnBlur
            renderInput={(params) => (
              <TextField {...params} label="Select Beneficiary" size="small" fullWidth />
            )}
          />


    </Grid>
            <Grid item xs={3}>
        <TextField
          label="Amount (BDT)"
          size="small"
          type="number"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter" && selectedBeneficiary && Number(amount) >= 1) {
              handleAddRow();
            }
          }}
          fullWidth
          inputProps={{ min: 0 }} // ✅ prevents negative numbers
        />
      </Grid>



          <Grid item xs={2}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleAddRow}
              disabled={!selectedBeneficiary || !amount}
            >
              Add
            </Button>
      

             
          </Grid>
        </Grid>

        {/* Table */}
   <Table size="small" style={{ marginTop: 8 }}>
  <TableHead>
    <TableRow>
      <TableCell align="center">Sl. No.</TableCell>
      <TableCell align="center">Name of Account Holder</TableCell>
      <TableCell align="center">Beneficiary Name</TableCell>
      <TableCell align="center">Bank Name</TableCell>
      <TableCell align="center">Branch Name</TableCell>
      <TableCell align="center">Bank A/C No.</TableCell>
      <TableCell align="center">Routing No.</TableCell>
      <TableCell align="center">Amount (BDT)</TableCell>
      <TableCell align="center">Action</TableCell>
    </TableRow>
  </TableHead>

  <TableBody>
    {rows.map((row, index) => (
      <TableRow key={row.id}>
        <TableCell align="center">{index + 1}</TableCell>
        <TableCell align="center">{row.name}</TableCell>
        <TableCell align="center">{row.beneficiaryName}</TableCell>
        <TableCell align="center">{row.bank.bankName}</TableCell>
        <TableCell align="center">{row.bank.branchName}</TableCell>
        <TableCell align="center">{row.accountNo}</TableCell>
        <TableCell align="center">{row.bank.routingNo}</TableCell>
        <TableCell align="center">{row.amount}</TableCell>

        <TableCell align="center">
          <Button
            variant="contained"
            color="secondary"
            onClick={() => {
              const updatedRows = rows.filter((_, i) => i !== index);
              setRows(updatedRows);
            }}
          >
            Delete
          </Button>
        </TableCell>
      </TableRow>
    ))}
  </TableBody>
</Table>

{/* Total Amount Section */}
<div
  style={{
    marginTop: 10,
    padding: "10px",
    textAlign: "right",
    fontWeight: "bold",
    // border: "1px solid Black",
    width: "85%",
  }}
>
  Total Amount (BDT):{" "}
  {rows
    .reduce((sum, item) => sum + Number(item.amount || 0), 0)
    .toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}
</div>

        <Box mt={2}>
          <Typography variant="body2" paragraph>
            Kindly execute the fund transfer instruction as stated above by
            debiting our bank account and transmit us the transfer advice in due course.
          </Typography>
          <Typography variant="body2">Thanks and best regards,</Typography>
        </Box>












        <Dialog open={openBeneficiaryModal}  onClose={handleClose}  maxWidth="sm" fullWidth>
  <DialogTitle>Add New Beneficiary</DialogTitle>
  <DialogContent>
      <TextField
      label="Beneficiary Name"
      fullWidth
      margin="dense"
      value={formData.beneficiaryName}
      onChange={(e) => setFormData({ ...formData, beneficiaryName: e.target.value })}
    />
    <TextField
      label="Account Holder Name"
      fullWidth
      margin="dense"
      value={formData.name}
      onChange={(e) => setFormData({ ...formData, name: e.target.value })}
    />
    <TextField
      label="Account No"
      fullWidth
      margin="dense"
      type="number"
      value={formData.accountNo}
      onChange={(e) => setFormData({ ...formData, accountNo: e.target.value })}
    />

    <Autocomplete
      options={banks}
      getOptionLabel={(option) => option.bankName}
      value={formData.bank}
      onChange={handleBankChange}
      renderInput={(params) => (
        <TextField {...params} label="Bank Name" margin="dense" fullWidth />
      )}
    />

    <Autocomplete
      options={branches}
      getOptionLabel={(option) =>
              option ? `${option.branchName} - ${option.routingNo}` : ""
            }
      value={formData.branch}
      onChange={(e, value) =>
        setFormData({ ...formData, branch: value })
      }
      renderInput={(params) => (
        <TextField {...params} label="Branch" margin="dense" fullWidth />
      )}
    />
  </DialogContent>
  <DialogActions>
 <Button onClick={handleClose} color="secondary">Cancel</Button>
<Button onClick={handleSubmitBeneficiary} color="primary">Submit</Button>

  </DialogActions>
</Dialog>


<Grid container justifyContent="space-between" style={{ marginTop: 30 }}>
  {/* Left Side → Primary */}



<Grid container spacing={2} style={{ marginTop: 5 }}>

  <Grid item xs={4} style={{ textAlign: "left" }}>
       <Autocomplete
      options={secondaryOptions}
      getOptionLabel={(option) => option.fullName} // ✅ show only name
      value={secondarySelected}
      onChange={(event, newValue) => setSecondarySelected(newValue)}
      renderInput={(params) => (
        <TextField {...params} label="Select Secondary Signatory" size="small" fullWidth />
      )}
    />

    {secondarySelected && (
      <>
        <Typography variant="body2" style={{ marginTop: 5 }}>
          <b>({secondarySelected.fullName})</b>
        </Typography>
        <Typography variant="body2">{secondarySelected.designation}</Typography>
      </>
    )}
  </Grid>
    <Grid item xs={4} >
     
  </Grid>

    <Grid item xs={4} >
        <Autocomplete
      options={primaryOptions}
      getOptionLabel={(option) => option.fullName} 
      value={primarySelected}
      onChange={(event, newValue) => setPrimarySelected(newValue)}
      renderInput={(params) => (
        <TextField {...params} label="Select Primary Signatory" size="small" fullWidth />
      )}
    />

    {primarySelected && (
      <>
        <Typography variant="body2" style={{ marginTop: 5 }}>
          <b>({primarySelected.fullName})</b>
        </Typography>
        <Typography variant="body2">{primarySelected.designation}</Typography>
      </>
    )}
  </Grid>
 </Grid>
 </Grid>

      </Paper>
          <Box mt={2} textAlign="center">
            <Button 
              variant="contained" 
              color="primary" 
              onClick={handleSubmit}
            >
              Submit
            </Button>
          </Box>
    </>
  )
}

export default FundTransferRequest
